import escapeStringRegexp from 'escape-string-regexp';

export class IncludeQueryTester {
    private static EQUAL_CHARS = [
        new Set(['a', 'à', 'á', 'a', 'â', 'ä', 'æ', 'ã', 'å', 'ā']),
        new Set(['c', 'ç', 'ć', 'č']),
        new Set(['e', 'è', 'é', 'ê', 'ë', 'ē', 'ė', 'ę']),
        new Set(['i', 'î', 'ï', 'í', 'ī', 'į', 'ì']),
        new Set(['l', 'ł']),
        new Set(['n', 'ń', 'ñ']),
        new Set(['o', 'ô', 'ö', 'ò', 'ó', 'œ', 'ø', 'ō', 'õ']),
        new Set(['s', 'ß', 'ś', 'š']),
        new Set(['u', 'û', 'ü', 'ù', 'ú', 'ū']),
        new Set(['y', 'ÿ', 'ў', 'ӯ', 'ү', 'ұ']),
        new Set(['z', 'ž', 'ź', 'ż']),
    ];

    private queryRegExp: RegExp;

    constructor(query: string) {
        this.queryRegExp = new RegExp(
            escapeStringRegexp(query.toLowerCase())
                .split('')
                .map(char => {
                    let equalsSet = IncludeQueryTester.EQUAL_CHARS.find(set => set.has(char));
                    return equalsSet ? this.getCharRegex(equalsSet) : char;
                })
                .join(''),
            'i'
        );
    }

    test(fullString: string | Array<string>): boolean {
        if (Array.isArray(fullString)) {
            return fullString.filter(str => typeof str === 'string').some(str => this.queryRegExp.test(str.toLowerCase()));
        } else {
            return this.queryRegExp.test(fullString);
        }
    }

    private getCharRegex(set: Set<string>): string {
        return `(?:${[...set.values()].join('|')})`;
    }
}
